<template>
  <section class="feature-introduction-editor mx-4 mt-4">
    <div class="row mb-4">
      <div class="col main-action-panel">
        <sc-button variant="primary mr-2">บันทึก</sc-button>
        <sc-button variant="danger">ลบทั้งประกาศ</sc-button>
      </div>
    </div>
    <div class="detail row">
      <div class="col col-2 platform-col px-4 py-4">
        <h3>OS ที่ต้องการประกาศ</h3>
        <div>
          <el-checkbox
            label="Android"
            v-model="form.platform.android.isSelected"
          ></el-checkbox>
          <el-input
            v-model="form.platform.android.version"
            placeholder="version"
            :disabled="!form.platform.android.isSelected"
          ></el-input>
          <el-checkbox
            label="iOS"
            v-model="form.platform.iOS.isSelected"
          ></el-checkbox>
          <el-input
            v-model="form.platform.iOS.version"
            placeholder="version"
            :disabled="!form.platform.iOS.isSelected"
          ></el-input>
        </div>
      </div>
      <div class="col py-4 page-col px-4">
        <h3>หน้าสำหรับประกาศ</h3>
        <FeatureIntroductionPageEditor
          :pageList="form.pageList"
          @textInputChange="handleOnTextInputChange"
          @deletePage="handleOnDeleteFeatureIntroductionPage"
          @imageChange="handleOnImageChange"
        />
        <sc-button variant="primary" @click="onAddPage">เพิ่มหน้า</sc-button>
      </div>
    </div>
  </section>
</template>

<script>
import { Input, Checkbox } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import DatePicker from "@/lib/components/DatePicker";
import ImagePickerModal from "@/lib/components/ImagePickerModal";

import FeatureIntroductionPageEditor from "../components/FeatureIntroductionPageEditor.vue";
import { FeatureIntroductionPresenter } from "@/presenters/featureIntroduction/FeatureIntroductionPresenter";

export default {
  components: {
    ScButton,
    "el-input": Input,
    DatePicker,
    ImagePickerModal,
    "el-checkbox": Checkbox,
    FeatureIntroductionPageEditor
  },
  props: ["form"],
  computed: {
    featureIntroductionPresenter() {
      return new FeatureIntroductionPresenter(this.form);
    }
  },
  methods: {
    onAddPage() {
      this.$emit("addPage");
    },
    handleOnTextInputChange(valueChanged) {
      this.$emit("textInputChange", valueChanged);
    },
    handleOnImageChange(imageChanged) {
      this.$emit("imageChanged", imageChanged);
    },
    handleOnDeleteFeatureIntroductionPage(pageIndexToDelete) {
      this.$emit("deletePage", pageIndexToDelete);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

h3 {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.22;
  letter-spacing: -0.1px;
  color: #000;
  margin-bottom: 20px;
}

.feature-introduction-editor {
  height: 100%;
  .main-action-panel {
    display: flex;
    justify-content: flex-start;
  }
  .detail {
    height: 100%;
  }
  .platform-col {
    height: 100%;
    min-width: 244px;
  }
  .page-col {
    border-left: 1px solid #dcdfe6;
  }
  .version-container {
    display: grid;
    grid-template-columns: 220px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/featureIntroduction/components/FeatureIntroductionEditor.vue